var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"switch"},[_c('input',_vm._g({attrs:{"type":"checkbox"}},_vm.listeners)),_c('span',{staticClass:"slider round"})])}
var staticRenderFns = []

export { render, staticRenderFns }